/** @lint */

/**
 * @module orb/features/_configuresearch
 */
define('orb/features/_configuresearch', ['orb/lib/_$', 'orb/nav'], function ($, nav) {
    'use strict';
    
    var exports = function () {
        var timer = null;
           
        $.ready(function () {
            var searchInput = $('#orb-search-q')[0],
                searchElements = $('.orb-nav-search input, .orb-nav-search button');
            
            if (!searchInput || !searchElements.length) {
                console.warn('Cannot configure Search: Search DOM elements missing.');
            }
            else {
                /**
                    Fade masthead to white when search is active.
                 */
                $.addEvent(searchElements, 'focus', function (e) {
                    clearTimeout(timer);
                    nav.closePanel();
                });
            
                /**
                    When the user types in the search input, create a suggestions
                    menu widget if we haven't already. Only active in English lang pages.
                 */
                if (window.orb && ('' + window.orb.lang).indexOf('en') === 0) {
                    $.setAttr(searchInput, 'autocomplete', 'off');
                    $.setAttr(searchInput, 'autocorrect', 'off');
                    $.setAttr(searchInput, 'autocapitalize', 'off');
                    $.setAttr(searchInput, 'spellcheck', 'false');
                    $.addEvent([searchInput], 'keydown', function (e) {
                        if (typeof searchInput.suggestions === 'undefined') {
                            searchInput.suggestions = 'initialising';
                            require(['orb/async/_suggestions'], function (Suggestions) {
                                searchInput.suggestions = new Suggestions(searchInput);
                            });
                        }
                    });
                }
            
                /**
                    Fade masthead to default shade when search feature is no longer active.
                 */
                $.addEvent(searchElements, 'blur', function (e) {
                    timer = setTimeout(function () {

                    }, 220);
                });
            }
        });
    };
    
    return exports;
});
